import { memo } from 'react';
import { UspSimple } from '~/lib/data-contract';
import { CMSLink, Tooltip } from '~/shared/components';
import parse from 'html-react-parser';
import { clsx } from 'clsx';
import styles from './usp.module.css';
import { MediaImage } from '../media-image/media-image.component';
import { Typography, TypographyProps } from '../typography/typography.component';

type Props = {
    uspItem?: UspSimple;
    className?: string;
} & Pick<TypographyProps<'span'>, 'variant'>;

export const Usp = memo(({ uspItem, className, variant = 'bodyXs' }: Props) => {
    const { link, text, image, description } = uspItem ?? {};

    if (!uspItem) {
        return null;
    }

    return (
        <Tooltip
            className={clsx(styles.root)}
            content={description ? parse(description) : undefined}
            position="left"
            textAlign="left"
        >
            <CMSLink
                href={link?.url}
                prefetch={false}
                tabIndex={link?.url ? undefined : 0}
                className={clsx(styles.rootLink, className)}
            >
                {image?.src && (
                    <MediaImage
                        src={image.src}
                        alt={image.alt ?? ''}
                        height={18}
                        mimeType="image/svg+xml"
                        width={18}
                        className={styles.image}
                    />
                )}
                <Typography as="span" variant={variant} fontWeight="semibold" uppercase>
                    {link?.text || text}
                </Typography>
            </CMSLink>
        </Tooltip>
    );
});

Usp.displayName = 'Usp';
export default Usp;
